import styled from 'styled-components';
export const Page = styled.div`
	padding: 28px 28px 28px 80px;
	background: #f4f5f6;
`;
export const PageTitle = styled.div`
	font-weight: bold;
	font-size: 24px;
	line-height: 33px;
	margin-bottom: 16px;
`;
export const PageSubtitle = styled.div`
	font-size: 16px;
	line-height: 22px;
	color: rgba(9, 21, 38, 0.6);
	margin-bottom: 64px;
`;
export const ReviewCard = styled.div`
	display: flex;
	margin-bottom: 80px;
`;
export const PersonCard = styled.div`
	display: flex;
	padding-top: 8px;
	margin-bottom: 16px;
`;
export const Button = styled.a`
	font-weight: bold;
	font-size: 13px;
	line-height: 18px;
	text-transform: uppercase;
	width: 144px;
	height: 36px;
	background-color: #12b7e7;
	border-radius: 10px;
	color: #ffffff !important;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	transition: background-color ease 0.3s;
	&:hover {
		background-color: #00a8d9;
	}
`;

export const PersonCardAvatar = styled.div`
	${Button} {
		margin-top: 24px;
	}
`;
export const PersonCardData = styled.div``;
export const CardData = styled.div`
	justify-self: flex-end;
`;
export const Title = styled.div`
	font-weight: bold;
	font-size: 20px;
	line-height: 28px;
	margin-bottom: 16px;
`;

export const PersonFio = styled.div`
	font-weight: bold;
	font-size: 16px;
	line-height: 22px;
	color: rgba(9, 21, 38, 0.6);
	margin-bottom: 8px;
`;

export const PersonText = styled.div`
	font-size: 16px;
	line-height: 22px;
	color: rgba(9, 21, 38, 0.6);
`;

export const Text = styled.div`
	font-size: 16px;
	line-height: 22px;
	color: rgba(9, 21, 38, 0.6);
	min-height: 66px;
	& + ${Button} {
		margin-top: 32px;
	}
`;

export const Logo = styled.div`
	width: 160px;
	height: 160px;
	background-repeat: no-repeat;
	justify-self: flex-start;
	margin-right: 48px;
	flex: 0 0 auto;
`;
export const Avatar = styled.div`
	width: 144px;
	height: 144px;
	margin-right: 24px;
	flex: 0 0 auto;
`;
